__turbopack_context__.v({
  "chevronArrow": "_gIoGW_chevronArrow",
  "claimFadeIn": "_gIoGW_claimFadeIn",
  "claimSlideUp": "_gIoGW_claimSlideUp",
  "closeButton": "_gIoGW_closeButton",
  "closeButtonDefault": "_gIoGW_closeButtonDefault",
  "closeButtonHero": "_gIoGW_closeButtonHero",
  "closeIcon": "_gIoGW_closeIcon",
  "ctaLink": "_gIoGW_ctaLink",
  "ctaLinkMobileOnly": "_gIoGW_ctaLinkMobileOnly",
  "ctaRow": "_gIoGW_ctaRow",
  "heroImageWrap": "_gIoGW_heroImageWrap",
  "kitImage": "_gIoGW_kitImage",
  "kitImageDefault": "_gIoGW_kitImageDefault",
  "kitImageFull": "_gIoGW_kitImageFull",
  "kitImagePro": "_gIoGW_kitImagePro",
  "overlay": "_gIoGW_overlay",
  "popupBody": "_gIoGW_popupBody",
  "popupCard": "_gIoGW_popupCard",
  "popupCardDefault": "_gIoGW_popupCardDefault",
  "popupCardHero": "_gIoGW_popupCardHero",
  "primaryCta": "_gIoGW_primaryCta",
  "subtitle": "_gIoGW_subtitle",
  "title": "_gIoGW_title",
  "typeformContainer": "_gIoGW_typeformContainer",
  "typeformModal": "_gIoGW_typeformModal",
});
